export default __webpack_public_path__ + "static/media/pay-point-icon.e89a1ce3.svg";